import { useState } from "react";
import { useSite } from "../../context/SiteContext";
import { api } from "../../lib/api";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { WhatsAppIcon } from "./Icons";
import { VoucherPreview } from "./VoucherPreview";

const WA_NUMBER = "905357952058";

const buildMessage = (f) =>
  [
    "Merhaba Lunessa Spa Masaj, hediye çeki talep etmek istiyorum.",
    "",
    `Paket / Hizmet: ${f.item}`,
    `Alıcı: ${f.recipient}`,
    `Gönderen: ${f.sender}`,
    f.note && `Not: ${f.note}`,
    f.date && `Tercih edilen tarih: ${new Date(f.date).toLocaleDateString("tr-TR")}`,
    "",
    "Ödeme ve teslim detayları için bilgi verebilir misiniz?",
  ]
    .filter((l) => l !== false && l !== undefined && l !== null)
    .join("\n");

const Err = ({ show, testId }) => (show ? <p className="mt-1 text-xs text-red-600" data-testid={testId}>Bu alan zorunludur.</p> : null);

export const GiftForm = ({ packages, services, item, setItem }) => {
  const { settings } = useSite();
  const [f, setF] = useState({ recipient: "", sender: "", note: "", date: "" });
  const [tried, setTried] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const data = { ...f, item, recipient: f.recipient.trim(), sender: f.sender.trim() };
  const valid = data.item && data.recipient && data.sender;
  const sel = "h-11 w-full rounded-md border border-input bg-white px-3 text-sm";

  const submit = (e) => {
    e.preventDefault();
    setTried(true);
    if (!valid) return;
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(buildMessage(data))}`, "_blank", "noopener");
    api.post("/gift-requests", { item: data.item, recipient: data.recipient, sender: data.sender, note: data.note, preferred_date: data.date }).catch(() => {});
  };

  return (
    <div className="grid items-start gap-10 lg:grid-cols-2 lg:gap-16">
      <form onSubmit={submit} noValidate className="card-lux space-y-5 p-6 sm:p-8" data-testid="gift-form">
        <div>
          <Label htmlFor="gift-item">Paket veya hizmet *</Label>
          <select id="gift-item" value={item} onChange={(e) => setItem(e.target.value)} className={`${sel} mt-1.5`} data-testid="gift-form-item">
            <option value="">Seçiniz</option>
            <optgroup label="Hediye Paketleri">
              {packages.map((p) => <option key={p.id} value={p.name}>{p.name}</option>)}
            </optgroup>
            <optgroup label="Tekil Hizmetler">
              {services.map((s) => <option key={s.id} value={s.title}>{s.title}</option>)}
            </optgroup>
          </select>
          <Err show={tried && !data.item} testId="gift-error-item" />
        </div>
        <div className="grid gap-5 sm:grid-cols-2">
          <div>
            <Label htmlFor="gift-recipient">Alıcı adı *</Label>
            <Input id="gift-recipient" maxLength={60} value={f.recipient} onChange={set("recipient")} className="mt-1.5 h-11 bg-white" data-testid="gift-form-recipient" />
            <Err show={tried && !data.recipient} testId="gift-error-recipient" />
          </div>
          <div>
            <Label htmlFor="gift-sender">Gönderen adı *</Label>
            <Input id="gift-sender" maxLength={60} value={f.sender} onChange={set("sender")} className="mt-1.5 h-11 bg-white" data-testid="gift-form-sender" />
            <Err show={tried && !data.sender} testId="gift-error-sender" />
          </div>
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label htmlFor="gift-note">Kısa not</Label>
            <span className="text-xs text-ink/45" data-testid="gift-note-count">{f.note.length}/150</span>
          </div>
          <Textarea id="gift-note" rows={3} maxLength={150} value={f.note} onChange={set("note")} className="mt-1.5 bg-white" data-testid="gift-form-note" />
        </div>
        <div>
          <Label htmlFor="gift-date">Tercih edilen tarih (opsiyonel)</Label>
          <Input id="gift-date" type="date" value={f.date} onChange={set("date")} className="mt-1.5 h-11 bg-white" data-testid="gift-form-date" />
        </div>
        <button type="submit" className="btn-gold w-full" data-testid="gift-form-submit">
          <WhatsAppIcon className="h-4 w-4" /> WhatsApp ile Hediye Çeki İste
        </button>
      </form>
      <div className="lg:sticky lg:top-28">
        <p className="mb-4 text-center text-xs font-medium uppercase tracking-[0.2em] text-gold-deep">Canlı Önizleme</p>
        <VoucherPreview {...data} badge={settings.campaign_active ? settings.campaign_badge : ""} />
      </div>
    </div>
  );
};
